import {
  AttrField,
  BooleanField,
  OrmModel,
  StringField
} from 'vuex-orm-decorators'
import { ApiResponse } from '@/dataAccess/dto/DTO'
import AbstractPerson from '@/dataAccess/models/AbstractPerson'

@OrmModel('employees')
export default class Employee extends AbstractPerson {
  @StringField()
  public username: string
  // TODO Why is `avatar` absolute URL, but `admin_change_url` is relative URL?
  // TODO RENAME to avatarUrl
  @StringField()
  public avatar: string
  @BooleanField(null)
  public isAdminOrSuperuser: boolean // TODO RENAME to isAdmin
  @BooleanField(null)
  public isSuperuser: boolean
  @StringField()
  public adminChangeUrl: string
  @AttrField()
  public clients: number[] // TODO currently it is just an array of IDs, use relations instead

  /*
   * Configuration for Vuex ORM Plugin Axios
   */
  static apiConfig = {
    // eslint-disable-next-line
    dataTransformer({ data, headers }) {
      return data.map(o => Employee.apiResponseMapper(o))
    }
  }

  /**
   * Map API response data structure to Employee data structure
   */
  public static apiResponseMapper(data: ApiResponse): ApiResponse {
    return {
      id: data.id,
      username: data.username,
      fullName: data.full_name,
      avatar: data.profile_picture,
      adminChangeUrl: data.admin_change_url,
      isAdminOrSuperuser: data.is_admin_or_superuser,
      isSuperuser: data.is_superuser,
      clients: data.clients,
      isArchived: data.is_archived
    }
  }
}
